import offensiveSlurs from '../public/OffensiveSlurs.json';

const letterAlternatives = {
    "a": ["4", "@"],
    "e": ["3"],
    "i": ["1", "!", "|"],
    "o": ["0"],
    "s": ["$", "5"],
    "t": ["7", "+"]
};

// Generate variants with substitutions
function generateVariants(word) {
    const variants = new Set([word]);

    // Replace letters with their alternatives to create variants
    for (let i = 0; i < word.length; i++) {
        const char = word[i].toLowerCase();
        if (letterAlternatives[char]) {
            letterAlternatives[char].forEach(sub => {
                const variant = word.slice(0, i) + sub + word.slice(i + 1);
                variants.add(variant);
            });
        }
    }
    return Array.from(variants);
}

// Calculate similarity using Levenshtein distance
function levenshteinDistance(s1, s2) {
    const len1 = s1.length;
    const len2 = s2.length;
    const matrix = Array.from({ length: len1 + 1 }, () => Array(len2 + 1).fill(0));

    for (let i = 0; i <= len1; i++) matrix[i][0] = i;
    for (let j = 0; j <= len2; j++) matrix[0][j] = j;

    for (let i = 1; i <= len1; i++) {
        for (let j = 1; j <= len2; j++) {
            const cost = s1[i - 1] === s2[j - 1] ? 0 : 1;
            matrix[i][j] = Math.min(
                matrix[i - 1][j] + 1,          // Deletion
                matrix[i][j - 1] + 1,          // Insertion
                matrix[i - 1][j - 1] + cost    // Substitution
            );
        }
    }

    return matrix[len1][len2];
}

function isSimilar(word1, word2, threshold) {
    const distance = levenshteinDistance(word1, word2);
    const similarity = 1 - distance / Math.max(word1.length, word2.length);
    return similarity >= threshold;
}

export function theAllSeeingEye(userName, threshold = 0.75) {
    userName = userName.toLowerCase();

    // First, check for exact matches in sentence
    if (offensiveSlurs.data.some(slur => userName.includes(slur))) {
        return true;
    }

    // Check against each offensive word and its variants
    for (const word of offensiveSlurs.data) {
        // Generate variants for the offensive word
        const variants = generateVariants(word);

        // Check each variant to see if it exists as a substring in the username
        for (const variant of variants) {
            if (userName.includes(variant)) {
                return true;  // Exact or near match in the sentence
            }

            // Use similarity check if exact match isn't found
            if (isSimilar(userName, variant, threshold)) {
                return true;  // Similar match in the sentence
            }
        }
    }

    return false; // No offensive match found
}